<template>
	<div :id="id">
		<b-card>
			<tooltip label="advertise Status" placement="right">
				<div class="d-inline ml-2">
					<label class="m-0 switch switch-icon switch-success switch-pill switch-sm">
						<input
							@change="handleOnChange"
							type="checkbox"
							v-model.lazy="data.status"
							class="switch-input"
						/>
						<span
							:title="$t('advertise Status')"
							class="switch-label"
							:data-on="$t('On')"
							:data-off="$t('Off')"
						></span>
						<span class="switch-handle"></span>
					</label>
				</div>
			</tooltip>

			<tooltip label="Random show" placement="right">
				<div class="d-inline ml-2">
					<label class="m-0 switch switch-icon switch-success switch-pill switch-sm">
						<input
							@change="handleOnChange"
							type="checkbox"
							v-model.lazy="data.random"
							class="switch-input"
						/>
						<span
							:title="$t('Random show')"
							class="switch-label"
							:data-on="$t('On')"
							:data-off="$t('Off')"
						></span>
						<span class="switch-handle"></span>
					</label>
				</div>
			</tooltip>

			<tooltip label="Random ratio" placement="right">
				<custom-slider
					min="10"
					max="100"
					step="10"
					v-model="data.random_ratio"
					@change="handleOnChange"
				/>
			</tooltip>

			<tooltip label="Script Code" placement="right">
				<codemirror
					ref="codemirror-ads"
					:options="cmOptionsEdit"
					v-model="data.code"
					@input="handleOnChange"
				></codemirror>
				<span
					v-show="errorCode"
					class="help is-danger invalid-feedback"
				>{{ $t('the code field is required') }}</span>
			</tooltip>

			<div class="btn-group" role="group">
				<b-button variant="danger" @click="remove" v-if="data.id" class="my-0" size="sm">
					<font-awesome-icon icon="trash" />
					{{$t('delete')}}
				</b-button>
				<b-button variant="dark" @click="cancel" v-else class="my-0" size="sm">
					<font-awesome-icon icon="times" />
					{{$t('cancel')}}
				</b-button>
				<b-button variant="primary" @click="save" class="my-0" size="sm">
					<font-awesome-icon icon="save" />
					{{$t('save')}}
				</b-button>
			</div>
		</b-card>
	</div>
</template>

<script>
import CustomSlider from 'vue-custom-range-slider'
import {codemirror} from 'vue-codemirror'
import cSwitch from './Switch'
import 'vue-custom-range-slider/dist/vue-custom-range-slider.css'

export default {
	name: 'response-extra-ads',
	components: {
		codemirror,
		cSwitch,
		CustomSlider,
	},

	props: {
		header: {
			type: String,
			default: () => 'ad',
		},
		dataSet: {
			type: [Object],
			required: true,
		},
	},
	data() {
		return {
			withSlot: null,
			cmOptionsEdit: {
				...this.$store.state.cm_base_options,
				mode: 'text/html',
			},

			cmOptionsView: {
				...this.$store.state.cm_base_options,
				// lineNumbers: !true,
				// theme: 'base16-dark',
				mode: 'text/html',
				readOnly: 1,
			},

			data: this.dataSet,
			errorCode: 0,
		}
	},
	computed: {
		id() {
			return 'ads_' + window.uuidv4(4)
		},
		mode() {
			return this.data.mode || 'show'
		},
	},
	methods: {
		handleOnChange() {
			this.$emit('change', this.data)
		},
		save() {
			if (this.data.code && this.data.code.length) {
				this.$emit('save', this.data)
				this.data = {
					...this.data,
					mode: 'show',
				}
				this.errorCode = 0
			} else {
				this.errorCode = 1
			}
		},

		remove() {
			this.$emit('remove', this.data)
		},
		edit() {
			this.data = {
				...this.data,
				mode: 'edit',
			}
		},
		cancel() {
			this.$emit('cancel')
		},

		subString(str) {
			const lines = str.slice().split('\n')
			return lines[0] + (lines.length > 1 ? '...\n' : '')
		},
	},
	created() {
		this.withSlot = this.$slots && this.$slots.default && this.$slots.default.length
	},
	watch: {
		dataSet(newDataSet) {
			this.data = {...newDataSet}
		},
	},
}
</script>


<style>
.slider {
	margin: 0;
}
</style>
